module.exports = __webpack_public_path__ + "static/media/online-orders.1b15061c.svg";